import { greyTheme } from "@foodpilot/foods";
import { DialogActions, Button } from "@mui/material";

type BaseFooterProps = {
    onCancelAction: () => void;
    onConfirmAction: () => void;
    canValidate?: boolean;
    cancelText: string;
    validateText: string;
};

export const BaseFooter = (props: BaseFooterProps) => {
    const { onCancelAction, onConfirmAction, canValidate = true, cancelText, validateText } = props;

    return (
        <DialogActions
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderTop: `1px solid ${greyTheme[500]}`,
                minHeight: "68px",
                paddingInline: "1rem",
                padding: "28px 32px 32px 32px",
            }}
        >
            <Button variant="text" onClick={onCancelAction}>
                {cancelText}
            </Button>
            <Button variant="primary" onClick={onConfirmAction} disabled={!canValidate}>
                {validateText}
            </Button>
        </DialogActions>
    );
};
